import { createAction } from 'redux-actions';
import { actionKey } from './constants';

export const messageReceived = createAction(`${actionKey}/RECEIVED`, message => message);
